window.mina = window.mina || {};
mina.cacheSelectors = function () {
  	mina.cache = {
	    $html                    : $('html'),
	    $body                    : $('body')
  	};
};
mina.init = function () {
	
};

$(document).ready(function() {
	$(mina.init);
});